<template>
  <v-dialog
    v-model="show"
    transition="dialog-bottom-transition"
    persistent
    width="600px"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn text class="mr-2" v-bind="attrs" v-on="on">
        <v-icon> mdi-tooltip-edit </v-icon>
        Edit Package
      </v-btn>
    </template>
    <template>
      <!-- <v-overlay :absolute="absolute" :value="overlay">
                <v-card class="secondary px-4 py-4">
                    <v-row>
                        <v-col class="col-12 black--text text-center">
                            <v-icon size="50" color="primary">mdi-alert-circle</v-icon>
                            <p class="body-1 py-3">Opps something went wrong, please try again.</p>
                            <v-btn icon color="primary" @click="cancelError()">
                                <v-icon>mdi-close-circle</v-icon>
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-card>
            </v-overlay> -->

      <v-card>
        <!-- <v-container> -->
        <v-row>
          <v-col cols="12" sm="12" md="12" lg="12">
            <v-card flat class="px-3 py-3">
              <v-row>
                <v-col class="text-center" cols="12">
                  <h2>{{ packageTitle }}</h2>
                  <v-divider class="py-1"></v-divider>
                </v-col>
              </v-row>
              <v-form ref="form" v-model="valid">
                <div class="px-4">
                  <v-row>
                    <v-col cols="12" class="text-center">
                      <h3 class="danetest--text">Compare Info</h3>
                    </v-col>
                    <v-col cols="12" v-if="newPages != ''">
                      <v-row justify="center">
                        <h3>
                          You can add
                          {{ pagesToAdd - newPages.length }} more
                          competitor(s)...
                        </h3>
                      </v-row>
                      <!-- <v-row v-if="agreement" justify="center">
                                                    <h3>You can add as many competitors as you want...</h3>
                                                    </v-row> -->
                    </v-col>
                    <v-col
                      v-if="
                        subscription.pageNames.length == 10 ||
                        newPages.length == 10
                      "
                      cols="12"
                      class="text-center"
                    >
                      <h3 style="padding: 10px">
                        Would you like to add more competitors for $10 per
                        competitor?
                      </h3>
                      <v-btn
                        style="padding: 10px"
                        @click="agreeToTerms()"
                        class="primary white--text"
                      >
                        Agree
                      </v-btn>
                    </v-col>
                    <v-col
                      v-if="
                        (overlay1 == false && newPages.length < 5) ||
                        (packageUpgraded && newPages.length < 10)
                      "
                      cols="12"
                    >
                      <v-text-field label="Search Companies"> </v-text-field>
                    </v-col>
                    <v-col v-if="overlay1 == false" cols="12">
                      <h3>Selected Pages</h3>
                    </v-col>
                    <v-col cols="12">
                      <v-card flat>
                        <v-list>
                          <!-- List Group For Current Subscription -->
                          <v-list-item-group v-if="overlay1 == true">
                            <v-list-item
                              v-for="page in this.subscription.pageNames"
                              :key="page.id"
                            >
                              <v-list-item-icon>
                                <v-avatar>
                                  <img
                                    sizes="50"
                                    src="../../assets/angry.png"
                                    alt="John"
                                  />
                                </v-avatar>
                              </v-list-item-icon>
                              <v-list-item-content>
                                <v-list-item-title>{{
                                  page.name
                                }}</v-list-item-title>
                              </v-list-item-content>
                            </v-list-item>
                          </v-list-item-group>
                          <!-- List Group For Edit Subscription -->
                          <v-list-item-group v-if="overlay1 == false">
                            <v-list-item
                              v-for="(newPages, index) in newPages"
                              :key="newPages.id"
                            >
                              <v-list-item-icon>
                                <v-avatar>
                                  <img
                                    sizes="50"
                                    src="../../assets/angry.png"
                                    alt="John"
                                  />
                                </v-avatar>
                              </v-list-item-icon>
                              <v-list-item-content>
                                <v-list-item-title>{{
                                  newPages.name
                                }}</v-list-item-title>
                              </v-list-item-content>
                              <v-btn
                                v-if="index != 0"
                                @click="deleteCompany(index)"
                                icon
                              >
                                <v-icon>mdi-close</v-icon>
                              </v-btn>
                              <v-list-item-content v-if="index == 0">
                                <v-list-item-title>
                                  - Primary page
                                </v-list-item-title>
                              </v-list-item-content>
                            </v-list-item>
                          </v-list-item-group>
                          <v-overlay :absolute="absolute" :value="overlay1">
                            <v-btn color="primary" @click="editPages()">
                              <v-icon>mdi-pencil</v-icon>
                              Edit Pages
                            </v-btn>
                          </v-overlay>
                        </v-list>
                      </v-card>
                    </v-col>
                    <v-col
                      v-if="overlay1 == false"
                      cols="12"
                      class="text-center py-0"
                    >
                      <v-btn
                        rounded
                        @click="confirmUpdate()"
                        class="primary white--text"
                      >
                        Confirm Update
                      </v-btn>
                    </v-col>
                    <v-col
                      cols="12"
                      class="py-0"
                      v-if="newPages.length == 5 && !packageUpgraded"
                    >
                      <v-card flat class="py-3 px-3 my-3 mx-3">
                        <v-row>
                          <v-col cols="12" class="text-center">
                            <h3 style="padding: 10px">Upgrade Package?</h3>
                            <v-btn
                              @click="upgradePackage()"
                              style="padding: 10px"
                              class="primary white--text"
                            >
                              Upgrade
                            </v-btn>
                          </v-col>
                        </v-row>
                      </v-card>
                    </v-col>
                  </v-row>
                </div>
              </v-form>
            </v-card>
          </v-col>
          <v-col cols="12" sm="12" md="12" lg="12">
            <v-card class="py-3 px-3 my-3 mx-3 mycardradius">
              <v-card-title>
                <v-icon color="primary" large left>
                  mdi-package-variant
                </v-icon>
                <span class="text-h6 font-weight-light"
                  >Current Subscription Info</span
                >
              </v-card-title>
              <!-- <h2 class="danetest--text">Current Subscription Info</h2> -->
              <v-divider class="py-2"></v-divider>
              <p class="mb-0">Package: {{ this.subscription.package }}</p>
              <p class="mb-0">Months: 12</p>
              <p class="mb-0">
                Pages:
                {{
                  this.subscription.pageNames
                    .map((page) => page.name)
                    .join(", ")
                }}
              </p>
              <p class="mb-0 mb-3">
                Date Started: {{ this.subscription.dateStarted }}
              </p>
              <v-divider class="py-2"></v-divider>
              <v-row class="px-2">
                <v-col cols="6">
                  <p class="mb-0">Total Price</p>
                </v-col>
                <v-col cols="6" class="text-right">
                  <p class="mb-0">${{ priceTotal }} p/m</p>
                </v-col>
              </v-row>
            </v-card>

            <v-row v-if="confirm">
              <v-col class="text-center" cols="12">
                <v-btn icon>
                  <v-icon color="primary">mdi-arrow-down-bold-circle</v-icon>
                </v-btn>
              </v-col>
            </v-row>

            <v-card v-if="confirm" class="py-3 px-3 my-3 mx-3 mycardradius">
              <v-card-title>
                <v-icon color="primary" large left> mdi-package-up </v-icon>
                <span class="text-h6 font-weight-light"
                  >Updated Subscription Info</span
                >
              </v-card-title>
              <v-divider class="py-2"></v-divider>
              <h3>Package: {{ this.package }}</h3>
              <h3>Months: 12</h3>
              <h3>Pages: {{ newPages.map((page) => page.name).join(", ") }}</h3>
              <h3 class="mb-3">Date Started: {{ Date.now() }}</h3>
              <v-divider class="py-2"></v-divider>
              <v-row class="px-2">
                <v-col cols="6">
                  <p class="mb-0">Total Price</p>
                </v-col>
                <v-col cols="6" class="text-right">
                  <p class="mb-0">${{ priceTotal }} p/m</p>
                </v-col>
              </v-row>
            </v-card>

            <!-- <v-card class="py-3 px-3 my-3 mx-3 mycardradius">
                            <v-card-title>
                                <v-icon large left>
                                    mdi-package-variant
                                </v-icon>
                                <span class="text-h6 font-weight-light">Upgraded Subscription Info</span>
                            </v-card-title>
                            <v-divider class="py-2"></v-divider>
                            <h3>Package: {{ this.package2 }}</h3>
                            <h3>Months: 12</h3>
                            <h3>Pages: {{ this.subscription.pageNames.map(page => page.name).join(', ') }}</h3>
                            <v-divider class="py-2"></v-divider>
                            <h3>Total Price p/m: ${{ priceTotal }}</h3>
                        </v-card> -->

            <v-card flat class="py-3 px-3">
              <v-row>
                <v-col class="col-6 text-center">
                  <v-btn
                    rounded
                    @click="cancelOperation()"
                    class="primary white--text"
                  >
                    Cancel
                  </v-btn>
                </v-col>
                <v-col class="col-6 text-center">
                  <v-btn
                    :loading="loading"
                    :disabled="!valid"
                    rounded
                    @click="createDashboardUser()"
                    class="primary white--text"
                  >
                    Submit
                  </v-btn>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>
        <!-- </v-container> -->
      </v-card>
    </template>
  </v-dialog>
</template>

<script>
export default {
  props: ["subscription"],
  data: () => ({
    overlay: false,
    overlay1: true,
    absolute: true,
    show: false,
    dialog: false,
    successResponse: "",
    errorMessage: false,
    loading: false,
    valid: false,
    rules: { required: (value) => !!value || "Required." },
    emailRules: [
      (v) => !!v || "E-mail is required",
      (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
    ],
    newPages: [],
    packageUpgraded: false,
    priceTotal: 120,
    pagesToAdd: 5,
    agreement: false,
    title: "Edit Package",
    quantity: 0,
    confirm: false,
    package: "",
  }),
  methods: {
    validate() {
      this.$refs.form.validate();
    },

    cancelError() {
      this.overlay = false;
    },
    cancelOperation() {
      this.show = false;
      (this.overlay1 = true),
        (this.newPages = []),
        (this.packageUpgraded = false),
        (this.pagesToAdd = 5);
    },
    editPages() {
      this.overlay1 = false;
      this.newPages = [...this.subscription.pageNames];
      if (this.subscription.pageNames.length <= 5) {
        this.package1();
      } else if (
        this.subscription.pageNames.length > 5 &&
        this.subscription.pageNames.length < 10
      ) {
        this.package2();
      } else if (this.subscription.pageNames.length > 10) {
        this.package3();
      }
      // console.log('this.newPages', this.newPages)
    },
    deleteCompany(index) {
      this.newPages.splice(index, 1);
    },
    upgradePackage() {
      this.package2();
    },
    confirmUpdate() {
      this.confirm = true;
    },
    //Package 1 setup
    package1() {
      this.quantity = 1;
      this.packageTitle = "Package 1";
      this.priceTotal = 130;
      this.pagesToAdd = 5;
    },
    //Package 2 setup
    package2() {
      this.quantity = 1;
      this.packageTitle = "Package 2";
      this.packageUpgraded = true;
      this.priceTotal = 185;
      this.pagesToAdd = 10;
    },
    //Package 3 setup
    package3() {
      this.quantity = this.packagePages.length - 10;
      this.packageTitle = "Package 3";
      this.agreement = true;
      this.packageUpgraded = true;
      this.priceTotal = 185;
      this.pagesToAdd = 0;
    },
  },
};
</script>

<style>
.mycardradius {
  border-radius: 20px !important;
}
</style>
